import DataTable from './dataTable'

/******************************************************************************
 *  Form Tracker
 *****************************************************************************/

/**
 * @type {FormTracker}
 */
export default class FormTracker extends DataTable {

    /**
     * @param {String} resource
     */
    constructor () {
        super('/trackerform', '/trackerform')
        this.columns = [
            this.prototypes.column('name', 'name', true, true),
            this.prototypes.column('form', 'form', true, true),
            this.prototypes.column('status', 'status', true, true),
            this.prototypes.column('leads_total', 'leads_total', false, true),
            this.prototypes.column('created_at', 'created_at', true, true),
            this.prototypes.column('updated_at', 'updated_at', true, true),
        ]
    }

    /**
     * Processa o response com os dados do form tracker,
     * de modo a satisfazer o formulário
     * 
     * @param {*} response 
     */
    parseFormResponse(response) {
        /** Processa os dados do último lead enviado para ser mostrado no select */
        let lastSend = [...response.data.last_send]
        lastSend = Object.values(lastSend).map(item => {
            item.value = (typeof item.value == 'undefined' ? '' : item.value)
            const nameValue = `${item.name[0]}:${item.value[0]}`

            return { label: nameValue, value: item.name[0] }
        })

        /** Processa os dados dos campos mapeados */
        let mapFields = {
            customer: {
                email: [],
                message: [],    
                mobile: [],
                name: [],
                phone: [],
                cpf: []
            },
            deal: {
                observations: []
            }
        }
        if (response.data.map_fields && response.data.map_fields.customer) {
            mapFields.customer = {
                email: response.data.map_fields.customer.email || [],
                message: response.data.map_fields.customer.message || [],
                mobile: response.data.map_fields.customer.mobile || [],
                name: response.data.map_fields.customer.name || [],
                phone: response.data.map_fields.customer.phone || [],
                cpf: response.data.map_fields.customer.cpf || []
            }
        }
        if (response.data.map_fields && response.data.map_fields.deal) {
            mapFields.deal = {
                observations: response.data.map_fields.deal.observations || []
            }
        }
        //tratativa de itens antigos salvo pelo vuejs
        for (const mapping in mapFields) {
            for (const field in mapFields[mapping]) {
                mapFields[mapping][field] = Object.values(mapFields[mapping][field]).map(value => {
                    if (value.includes(':')) value = value.split(':')[0]
                    return value
                })
            }
        }
        // remoção de itens repetido no array
        for (const mapping in mapFields) {
            for (const field in mapFields[mapping]) {
                mapFields[mapping][field] = [...new Set(mapFields[mapping][field])]
            }
        }

        /** Processa os dados dos campos extras */
        let extraFields = { ...response.data.extra_fields }
        if (extraFields.deal && typeof extraFields.deal.length === 'undefined') {
            if (extraFields.deal.product_id) {
                extraFields.deal.product_id = extraFields.deal.product_id.map(id => {
                    return typeof id === 'string' && id.trim().match(/^[0-9]+$/) ? parseInt(id) : id
                })
            }

            extraFields.deal.funnel_stage_id = extraFields.deal.funnel_stage_id ?
                parseInt(extraFields.deal.funnel_stage_id[0]) :
                null

            extraFields.deal.funnel_stage_status_id = extraFields.deal.funnel_stage_status_id ?
                parseInt(extraFields.deal.funnel_stage_status_id[0]) :
                null
        } else {
            extraFields.deal = {
                product_id: [],
                funnel_stage_id: null,
                funnel_stage_status_id: null
            }
        }

        let productOptions = []
        productOptions = Object.values(response.data.last_send)
            .filter(item => {
                return item
            })
            .map(item => {
                return { label: `${item.name[0]}:${item.value[0]}`, value: item.name[0] }
            })
        
        response.data.last_send = [...lastSend]
        response.data.map_fields = { ...mapFields }
        response.data.extra_fields = { ...extraFields }
        response.data.product_options = [{
            title: 'Empreendimentos do formulário',
            items: [...productOptions]
        }]

        return response
    }

    /**
     * Requisição para buscar uma instância de form tracker de acordo
     * com o ID
     * 
     * @param {*} id 
     */
    get(id, config) {
        return super.get('', id, {}, config).then(response => {
            return this.parseFormResponse(response)
        })
    }

    /**
     * Requisição para atualizar uma instância de form tracker
     * 
     * @param {*} id 
     * @param {*} formData 
     */
    update(id, formData) {
        return super.update('', id, formData).then(response => {
            response.data = { ...this.parseFormResponse(response.data) }

            return response
        })
    }
}

